"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Errors = require("./Constants/Errors");
var StoresContext_1 = require("./StoresContext");
var isDeeplyOrReferentiallyEqual_1 = require("./Utils/isDeeplyOrReferentiallyEqual");
/**
 * A higher order function returning a higher order component, allowing
 * a component to be connected to an application's Depo "state" by
 * automatically subscribing it to udpates from the stores from which mapped
 * props data is observed.
 *
 * @param mapStateToProps A function to map immutable data from a depo state's "value",
 *  or actions from any of its stores. It must return an object containing one or more properties
 *  to be shallow merged into the connected component's props.
 */
var connect = function (mapStateToProps) {
    /**
     * A higher order component returning a connected component.
     *
     * @param Component A consumer-authored component to be connected to the data
     *  observed by the previous provided `mapStateToProps()` function.
     */
    var Hoc = function (Component) {
        // From the consumer-authored component's own props (`TOriginalProps`),
        // Remove any keys returned from `mapStateToProps` (`TMappedProps`) or
        // or any keys injected by the stores context `IContextProps`.
        var DepoConnectedComponent = /** @class */ (function (_super) {
            __extends(DepoConnectedComponent, _super);
            function DepoConnectedComponent(props) {
                var _this = _super.call(this, props) || this;
                _this.storeSubscriptions = [];
                if (typeof mapStateToProps !== 'function') {
                    throw new Error(Errors.INVALID_ARGUMENT());
                }
                _this.state = mapStateToProps(_this.props.valueProxy, _this.props.actions);
                _this.prevState = _this.state;
                _this.storeNamesToSubscribe = _this.props.getStoreNames();
                _this.handleStoreUpdate = _this.handleStoreUpdate.bind(_this);
                return _this;
            }
            DepoConnectedComponent.prototype.componentDidMount = function () {
                var _this = this;
                this.storeSubscriptions = this.storeNamesToSubscribe.map(function (storeName) {
                    return _this.props.depoState.stores[storeName].update$.subscribe(_this.handleStoreUpdate);
                });
            };
            DepoConnectedComponent.prototype.componentWillUnmount = function () {
                while (this.storeSubscriptions.length > 0)
                    this.storeSubscriptions.pop().unsubscribe();
            };
            DepoConnectedComponent.prototype.render = function () {
                // Remove context props from own props
                var _a = this.props, _ = _a.depoState, __ = _a.getStoreNames, ___ = _a.valueProxy, rest = __rest(_a, ["depoState", "getStoreNames", "valueProxy"]);
                var childProps = __assign({}, this.state, rest);
                return React.createElement(Component, __assign({}, childProps));
            };
            DepoConnectedComponent.prototype.handleStoreUpdate = function () {
                var nextState = mapStateToProps(this.props.depoState.value, this.props.actions);
                if (!isDeeplyOrReferentiallyEqual_1.default(nextState, this.prevState)) {
                    this.setState(__assign({}, nextState));
                }
                this.prevState = nextState;
            };
            DepoConnectedComponent.displayName = "DepoConnectedComponent(" + (Component.displayName ||
                Component.name) + ")";
            return DepoConnectedComponent;
        }(React.Component));
        var WithContext = function (props) { return (React.createElement(StoresContext_1.default.Consumer, null, function (context) {
            if (context === null)
                throw new Error(Errors.STORES_NOT_AVAILABLE());
            return (React.createElement(DepoConnectedComponent, __assign({}, props, { depoState: context.depoState, getStoreNames: context.getStoreNames, valueProxy: context.valueProxy, actions: context.actions })));
        })); };
        WithContext.displayName = "DepoConnectedComponentWithStoresContext(" + (Component.displayName ||
            Component.name) + ")";
        WithContext.Component = Component;
        return WithContext;
    };
    return Hoc;
};
exports.default = connect;
//# sourceMappingURL=connect.js.map